(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('product-specs');
  if (!section) return;
  var tabs   = section.querySelectorAll('.specs-tab');
  var panels = section.querySelectorAll('.specs-panel');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('specs-tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) { p.classList.add('specs-panel--hidden'); });
      tab.classList.add('specs-tab--active');
      tab.setAttribute('aria-selected', 'true');
      var panel = section.querySelector('#specs-panel-' + tab.dataset.tab);
      if (panel) panel.classList.remove('specs-panel--hidden');
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
